<template>
  <div>
    <div class="foot flex-center pc">
      <img
        :src="basicInfo.footer_logo"
        alt=""
        style="height: 125px; padding-right: 40px"
      />
      <div
        style="
          flex: 1;
          padding: 0 40px;
          border-left: 1px solid #666;
          border-right: 1px solid #666;
        "
      >
        <div>
          <span
            style="margin-left: 0"
            class="typeClick"
            @click="handleSelect('home')"
            >首页</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('about')">医院介绍</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('environment')"
            >医院环境</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('honour')"
            >医院荣誉</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('characteristic')"
            >特色医疗</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('medicalRecord')"
            >病历简介</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('news')">新闻资讯</span
          ><span style="font-size: 20px">﹥</span
          ><span class="typeClick" @click="handleSelect('contact')"
            >联系我们</span
          >
        </div>
        <div style="margin-top: 50px">咨询电话：{{ basicInfo.phone }}</div>
        <div style="margin-top: 10px">
          医院地址：{{ basicInfo.hospital_address }}
        </div>
        <div style="margin-top: 10px"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#fff;">主体备案：{{ basicInfo.beian }}</a></div>
        <div style="margin-top: 10px">
          {{ basicInfo.registration_num }}
        </div>
      </div>
      <div style="padding-left: 40px">
        <div style="position: relative; padding: 7px">
          <div class="left-top divBorder"></div>
          <div class="left-bottom divBorder"></div>
          <div class="right-top divBorder"></div>
          <div class="right-bottom divBorder"></div>
          <img
            :src="basicInfo.wechat_image"
            alt=""
            style="width: 125px; height: 125px"
          />
        </div>
        <div style="text-align: center; font-size: 15px; margin-top: 10px">
          官方公众号
        </div>
      </div>
    </div>
    <div
      class="mobile"
      style="
        color: #fff;
        background: #333;
        font-size: 0.1rem;
        margin-top: 0.1rem;
        padding: 0.2rem 0.1rem;
        margin-bottom:0.6rem;
      "
    >
      <div>
        <div class="flex-center">
          <!-- <div style="">
          <img :src="basicInfo.footer_logo" alt="" style="height: 0.6rem" />
        </div> -->
          <div style="flex: 1">
            <div class="flex-center">
              <div style="margin-right: 0.05rem">
                <i class="el-icon-phone-outline" style="font-size: 0.2rem"></i>
              </div>
              <div>
                {{ basicInfo.phone }}
              </div>
            </div>
            <div style="margin-top: 0.1rem" class="flex-center">
              <div style="margin-right: 0.05rem">
                <i
                  class="el-icon-location-outline"
                  style="font-size: 0.2rem"
                ></i>
              </div>
              <div>
                {{ basicInfo.hospital_address }}
              </div>
            </div>
          </div>
          <div style="">
            <div style="position: relative; padding: 7px">
              <div class="left-top divBorder"></div>
              <div class="left-bottom divBorder"></div>
              <div class="right-top divBorder"></div>
              <div class="right-bottom divBorder"></div>
              <img
                :src="basicInfo.wechat_image"
                alt=""
                style="height: 0.8rem"
              />
            </div>
            <div style="text-align:center;margin-top:0.1rem;">
              官方公众号
            </div>
          </div>
        </div>
        <div style="margin-top: 0.2rem; text-align: center">
          {{ basicInfo.registration_num }}
        </div>
        <div style="margin-top: 0.1rem; text-align: center">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#fff;">主体备案：{{ basicInfo.beian }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getsite } from "@/api/common";
import $ from "jquery";
export default {
  name: "Footer",
  data() {
    return {
      basicInfo: {},
    };
  },
  mounted() {
    getsite().then((res) => {
      this.basicInfo = res.data;
    });
  },
  methods: {
    handleSelect(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      } else {
        $("body,html").animate({ scrollTop: 0 }, 1000);
      }
      //
    },
  },
};
</script>
<style>
.divBorder {
  position: absolute;
  height: 14px;
  width: 14px;
  background: none;
}
.left-top {
  left: 0;
  top: 0;
  border-left: 2px solid #fff;
  border-top: 2px solid #fff;
}
.left-bottom {
  left: 0;
  bottom: 0;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
}
.right-top {
  right: 0;
  top: 0;
  border-right: 2px solid #fff;
  border-top: 2px solid #fff;
}
.right-bottom {
  right: 0;
  bottom: 0;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
}
.foot .typeClick:hover {
  color: #439392;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue